<script setup lang="ts">
// PROPS
interface Props {
    appliedFilters: AppliedFilter[];
}

defineProps<Props>();
</script>

<template>
    <BaseDeletableBadge
        v-for="(filter, index) in appliedFilters"
        :key="index"
        color="primary"
        variant="soft"
        size="lg"
        :label="filter.label"
        @delete="filter.deleteHandler"
    />
</template>
